__turbopack_context__.v({
  "back_button": "BackButton-module-scss-module__C-d13a__back_button",
});
